export default __webpack_public_path__ + "media/vendor/paper-dashboard-2-pro-html-v2.0.1/assets/img/bg/jeremy-yap-fcc0c0f7a9c66ce9ae1812827cff4804.jpg";